import React, { useEffect, useRef } from "react";

export default function ParkMap({ lat, lng, name }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    async function init() {
      const L = (await import("leaflet")).default || (await import("leaflet"));
      if (cancelled || !ref.current) return;
      if (mapRef.current) {
        mapRef.current.setView([lat, lng], 12);
        return;
      }
      const map = L.map(ref.current, { scrollWheelZoom: false }).setView([lat, lng], 12);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '© OpenStreetMap',
        maxZoom: 18,
      }).addTo(map);
      const customIcon = L.divIcon({
        className: "ps-pin",
        html: `<div style="background:#2C5545;color:white;padding:6px 10px;border-radius:999px;font-weight:600;font-size:12px;font-family:Outfit, sans-serif;box-shadow:0 6px 18px rgba(0,0,0,0.18);white-space:nowrap;">${name}</div>`,
        iconSize: null,
        iconAnchor: [0, 0],
      });
      L.marker([lat, lng], { icon: customIcon }).addTo(map);
      mapRef.current = map;
    }
    init();
    return () => { cancelled = true; };
  }, [lat, lng, name]);

  return <div ref={ref} className="h-72 sm:h-96 w-full rounded-xl overflow-hidden border border-border" data-testid="park-map" />;
}
